import api from './api'

export default {
  month(params) {
    return api.get('/filiation/filiation-balances/month', { params })
  },

  purchases(balanceId, params) {
    return api.get(`/filiation/filiation-balances/${balanceId}/purchases`, {
      params,
    })
  },

  subscriptions(balanceId, params) {
    return api.get(`/filiation/filiation-balances/${balanceId}/subscriptions`, {
      params,
    })
  },

  videoWatches(balanceId, params) {
    return api.get(`/filiation/filiation-balances/${balanceId}/video-watches`, {
      params,
    })
  },
}
